<div mat-dialog-title class="flex flex-row">
    {{ pix ? 'Aguardando PIX no terminal' : 'Lembre-se' }}
    <div class="flex-fill"></div>
    <div class="btn-options">
        <button color="primary" (click)="dialogRef.close()" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content>
    <div *ngIf="pix" style="padding: 16px; text-align: center;">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #4CAF50;">pix</mat-icon>
        <p>Realize o pagamento PIX no terminal e aguarde a confirmação.</p>
    </div>
    <div *ngIf="!pix" class="flex flex-fill">
        <div class="table">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="label">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element"> {{element.label}} </td>
                </ng-container>
              
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef> </th>
                  <td mat-cell *matCellDef="let element" [ngClass]="element?.label === '' ? 'border' : '' "> {{element.value}} </td>
                </ng-container>
              
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
        </div>
    </div>
</div>


<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>